<template>
  <div class="page-maindiv">
    <!-- Main -->
    <div class="area-main">
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-title">
          {{ $t('menu.scopri_progetti') }}
        </div>
      </div>
      <div class="area-description" v-if="!loading">
        <div v-html="pageDescription" v-if="!loading"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CulturalProjects',
  data: function() {
    return {
      pageDescriptionRecord: "",
      loading: true,
    };
  },
  created() {
    this.fetchCulturalProjects()
  },
  computed: {
    pageDescription() {
      let desc = "";
      if (this.pageDescriptionRecord != null)
        for (let trad in this.pageDescriptionRecord["traduzioni"]) {
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith("it"))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
        }
      return desc;
    },
  },
  methods: {
    async fetchCulturalProjects() {
      const pageDescriptionData = await this.$client.getItems("pagine", {
        fields: ["*", "traduzioni.*"],
        filter: {
          nome: {
            eq: 'progetti_culturali'
          }
        }
      });
      if (pageDescriptionData.data !== null && pageDescriptionData.data.length > 0)
        this.pageDescriptionRecord = pageDescriptionData.data[0];

      this.loading = false;
    },
  }
}
</script>

<style>
</style>